import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '作业说明',
    type: 'BJ_DESC',
}
